import { render, staticRenderFns } from "./resumen-totales.vue?vue&type=template&id=57255838&scoped=true&"
import script from "./resumen-totales.vue?vue&type=script&lang=ts&"
export * from "./resumen-totales.vue?vue&type=script&lang=ts&"
import style0 from "./resumen-totales.vue?vue&type=style&index=0&id=57255838&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57255838",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VDivider,VIcon,VRow,VSkeletonLoader,VSpacer})
